import { render, staticRenderFns } from "./PedidoManual.vue?vue&type=template&id=f08c283c&scoped=true"
import script from "./PedidoManual.vue?vue&type=script&lang=js"
export * from "./PedidoManual.vue?vue&type=script&lang=js"
import style0 from "./PedidoManual.vue?vue&type=style&index=0&id=f08c283c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08c283c",
  null
  
)

export default component.exports